__turbopack_context__.v({
  "disabled": "list-item-module-scss-module__QNQs1a__disabled",
  "icon": "list-item-module-scss-module__QNQs1a__icon",
  "large": "list-item-module-scss-module__QNQs1a__large",
  "list-item": "list-item-module-scss-module__QNQs1a__list-item",
  "medium": "list-item-module-scss-module__QNQs1a__medium",
  "small": "list-item-module-scss-module__QNQs1a__small",
  "subtitle": "list-item-module-scss-module__QNQs1a__subtitle",
  "title": "list-item-module-scss-module__QNQs1a__title",
  "x-large": "list-item-module-scss-module__QNQs1a__x-large",
});
